"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageLevelHeading_1 = require("./PageLevelHeading");
exports.default = PageLevelHeading_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelHeading/index.js
// module id = 158
// module chunks = 8